module.exports = __webpack_public_path__ + "img/b_home_01_s.392dac97.jpg";